// extracted by mini-css-extract-plugin
module.exports = {"root":"AvailableBalance_root__17A5r"};